import $ from "jquery";
export default class ImageUpload {
    static mount() {
        $('.ce-submission .panel--images').each(function () {
            new ImageUpload($(this));
        });
    }
    constructor($panel) {
        this.$panel = $panel;
        this.orderCounter = 5;
        this.$addButton = $(".wp-block-button__add-image", $panel);
        this.$fileInputs = $("input[type=file]", $panel);
        this.$previewContainer = $(".panel__content__preview", $panel);
        let that = this;
        this.$addButton.on('click', function (event) {
            event.preventDefault();
            const $input = that.findFreeInput();
            if ($input) {
                $input.trigger('click');
            }
        });
        this.checkButtonState();
        $('.form__file-preview__remove', this.$panel).on("click", (event) => { that.removeButtonClicked(event); });
        this.$fileInputs.on("change", function () {
            const input = this;
            var files = !!input.files ? input.files : [];
            const inputName = $(input).attr("name");
            if (!files.length || !window.FileReader)
                return;
            const maxAllowedSize = 5 * 1024 * 1024;
            if (files[0].size > maxAllowedSize) {
                alert("Eine Datei darf nicht größer als 5 MB sein.");
                $(input).val("");
                return;
            }
            if (/^image/.test(files[0].type)) {
                let reader = new FileReader();
                reader.onloadend = function (e) {
                    if (null == this.result) {
                        alert("Fehler beim laden der Datei.");
                        return;
                    }
                    if (typeof this.result !== 'string' && !(this.result instanceof String)) {
                        alert("Bei der Datei handelt es sich nicht um eine JPEG oder PNG Datei");
                        return;
                    }
                    let header = that.base64MimeType(this.result);
                    if (!header || !that.checkMimeType(header)) {
                        alert("Bei der Datei handelt es sich nicht um eine JPEG oder PNG Datei");
                        return;
                    }
                    $("input[name='" + $(input).attr("name") + "_order']").val(that.orderCounter++);
                    let $preview = $('<div class="form__file-preview" data-refinput="' + inputName + '" ><button class="wp-element-button form__file-preview__remove" aria-label="Löschen"></button></div>');
                    that.$previewContainer.append($preview);
                    $preview.css("background-image", "url(" + this.result + ")");
                    $('.form__file-preview__remove', $preview).on("click", (event) => { that.removeButtonClicked(event); });
                };
                reader.readAsDataURL(files[0]);
            }
            else {
                alert("Bei der Datei handelt es sich nicht um eine JPEG oder PNG Datei");
            }
            that.checkButtonState();
        });
    }
    base64MimeType(encoded) {
        if (!encoded)
            return "";
        var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
        if (mime && mime.length)
            return mime[1];
    }
    checkButtonState() {
        const $input = this.findFreeInput();
        if ($input) {
            this.$addButton.removeAttr("disabled");
        }
        else {
            this.$addButton.attr("disabled", "disabled");
        }
    }
    checkMimeType(header) {
        switch (header) {
            case "image/png":
                return true;
            case "image/jpeg":
                return true;
        }
        return false;
    }
    removeButtonClicked(event) {
        event.preventDefault();
        let $preview = $(event.target).parent('.form__file-preview');
        let input = $("input[name='" + $preview.data('refinput') + "']");
        let inputName = input.attr("name");
        $('input[name="token_' + inputName + '"]', $preview.parent()).remove();
        $preview.remove();
        input.val("");
        $("input[name='" + $preview.data('refinput') + "_order']").val(this.orderCounter++);
        input[0].dataset.imageexists = "";
        this.checkButtonState();
    }
    findFreeInput() {
        let $fileInputs = $("input[type=file]", this.$panel).toArray();
        for (let i = 0; i < $fileInputs.length; i++) {
            let $elem = $(this.$fileInputs[i]);
            let val = $elem.val();
            if (!val && $elem[0].dataset.imageexists !== "1") {
                return $elem;
            }
        }
        return null;
    }
}
